import { Directive, ElementRef, HostBinding } from "@angular/core";
import { FocusTabButton } from "../types/focus-tab-btn.model";

/**
 * Sometimes we want to apply focus only on the parent element
 * this directive will help target which button should be clicked on enter.
 */
@Directive({
    selector: '[focusTabBtn]'
})
export class FocusTabButtonDirective implements FocusTabButton{

    @HostBinding('class') get getClass(){
        return {
            'focus-tab-btn': true
        }
    }

    constructor(private _el: ElementRef<HTMLElement>){

    }

    click(): void {
        this._el.nativeElement.click();
    }
}